import type { ReduxModuleDefinition } from '@exodus/redux-dependency-injection';

const initialState = { enabled: false };

const testnetsReduxDefinition = () =>
  ({
    id: 'testnets',
    type: 'redux-module',
    initialState,
    eventReducers: {
      testnetsEnabled: (state, payload) => ({ ...state, enabled: payload }),
    },
    selectorDefinitions: [],
  }) as const satisfies ReduxModuleDefinition;

export default testnetsReduxDefinition;
